import * as React from "react";

const SvgClipboardlist = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="nonzero">
      <path d="M12 11a1 1 0 1 0 0 2v-2ZM15 13a1 1 0 1 0 0-2v2ZM12 15a1 1 0 1 0 0 2v-2ZM15 17a1 1 0 1 0 0-2v2ZM9 11a1 1 0 1 0 0 2v-2ZM9.01 13a1 1 0 1 0 0-2v2ZM9 15a1 1 0 1 0 0 2v-2ZM9.01 17a1 1 0 1 0 0-2v2ZM18 7v12h2V7zM17 20H7v2h10zM6 19V7H4v12zM7 6h2V4H7zM15 6h2V4h-2zM7 20a1 1 0 0 1-1-1H4a3 3 0 0 0 3 3v-2ZM18 19a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2ZM20 7a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1h2ZM6 7a1 1 0 0 1 1-1V4a3 3 0 0 0-3 3h2ZM12 13h3v-2h-3zM12 17h3v-2h-3zM11 4h2V2h-2zM13 6h-2v2h2z" />
      <path d="M11 6a1 1 0 0 1-1-1H8a3 3 0 0 0 3 3V6ZM14 5a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2ZM13 4a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2ZM11 2a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1V2ZM9 13h.01v-2H9zM9 17h.01v-2H9z" />
    </g>
  </svg>
);

export default SvgClipboardlist;
